import { useEffect } from "react";

const CaseStudyFetcher = ({ onDataFetched }) => {
  useEffect(() => {
    const fetchEntries = async () => {
      try {
        setTimeout(() => {
          onDataFetched();
        }, 1000);
      } catch (error) {
        console.error("Error fetching case studies:", error);
        onDataFetched([]);
      }
    };

    fetchEntries();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default CaseStudyFetcher;
